import React, { Fragment } from 'react'
import styled from 'styled-components'

import ActionRegister from '@/docs-partials/api/endpoints/action-register.mdx'
import Autocomplete from '@/docs-partials/api/endpoints/autocomplete.mdx'
import Categories from '@/docs-partials/api/endpoints/categories.mdx'
import ChannelsSearch from '@/docs-partials/api/endpoints/channel-search.mdx'
import GetGifById from '@/docs-partials/api/endpoints/get-gif-by-id.mdx'
import GetGifsById from '@/docs-partials/api/endpoints/get-gifs-by-id.mdx'
import Random from '@/docs-partials/api/endpoints/random.mdx'
import RandomId from '@/docs-partials/api/endpoints/random-id.mdx'
import Search from '@/docs-partials/api/endpoints/search.mdx'
import SearchSuggestions from '@/docs-partials/api/endpoints/search-suggestions.mdx'
import SectionHeader from '@/docs-partials/api/endpoints/section-header.mdx'
import Translate from '@/docs-partials/api/endpoints/translate.mdx'
import Trending from '@/docs-partials/api/endpoints/trending.mdx'
import TrendingSearchTerms from '@/docs-partials/api/endpoints/trending-search-terms.mdx'
import Upload from '@/docs-partials/api/endpoints/upload.mdx'
import { Anchor } from '@/components/ui/anchor'
import { ApiDocsSectionWrapper } from '@/components/common/api-docs-section-wrapper'
import { Divider } from '@/components/ui/divider'

const EndpointsContainer = styled.div``

type EndpointProps = {
  anchorId: string
}

const Endpoint: React.FC<EndpointProps> = ({ children, anchorId }) => {
  return (
    <ApiDocsSectionWrapper>
      <Divider />
      <Anchor pathname="/docs/api/endpoint" id={anchorId} />
      {children}
    </ApiDocsSectionWrapper>
  )
}

const EndpointsPage = () => {
  return (
    <Fragment>
      <EndpointsContainer>
        <SectionHeader />
        <Endpoint anchorId="trending">
          <Trending />
        </Endpoint>
        <Endpoint anchorId="search">
          <Search />
        </Endpoint>
        <Endpoint anchorId="translate">
          <Translate />
        </Endpoint>
        <Endpoint anchorId="random">
          <Random />
        </Endpoint>
        <Endpoint anchorId="action-register">
          <ActionRegister />
        </Endpoint>
        <Endpoint anchorId="random-id">
          <RandomId />
        </Endpoint>
        <Endpoint anchorId="get-gif-by-id">
          <GetGifById />
        </Endpoint>
        <Endpoint anchorId="get-gifs-by-id">
          <GetGifsById />
        </Endpoint>
        <Endpoint anchorId="upload">
          <Upload />
        </Endpoint>
        <Endpoint anchorId="categories">
          <Categories />
        </Endpoint>
        <Endpoint anchorId="autocomplete">
          <Autocomplete />
        </Endpoint>
        <Endpoint anchorId="channel-search">
          <ChannelsSearch />
        </Endpoint>
        <Endpoint anchorId="search-suggestions">
          <SearchSuggestions />
        </Endpoint>
        <Endpoint anchorId="trending-search-terms">
          <TrendingSearchTerms />
        </Endpoint>
      </EndpointsContainer>
    </Fragment>
  )
}

export default EndpointsPage
